import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, RequiredValidator, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PrdLocationService } from '../../../../services/prdLocation.service';
import { SecurityService } from '../../../../services/security.service';
import { ErrorStateMatcher1 } from '../../../error-state-matcher1';
import { IAddLocationProduction } from '../../../Interfaces/ilocation';

@Component({
  selector: 'app-addlocationproduction',
  templateUrl: './addlocationproduction.component.html',
})

export class AddLocationProductionComponent implements OnInit {
  formedit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  mensaje: string="";

  constructor(
    private formBuilder: FormBuilder, 
    private securityService: SecurityService,
    private router: Router,
    private prdLocationService:PrdLocationService,
    private dialogRef: MatDialogRef<AddLocationProductionComponent>,
    private _snackBar: MatSnackBar
  )
  {
    this.formedit = formBuilder.group({
      registryTimeout: [0, [Validators.required, Validators.min(1), Validators.max(60)]],
      print:[false]
    })
  }
  selectedvalue: number; selectedview: string;

  ngOnInit() {
    this.mensaje = ""; 
  }


  Cancel() {
    this.dialogRef.close();
  }

  Save()
  {
    try {
      const IReg: IAddLocationProduction =
      {
        id:this.prdLocationService.locationID,
        registryTimeout: this.formedit.value.registryTimeout,
print:this.formedit.value.print
      };
      this.prdLocationService.AddProduction(IReg).subscribe(results => {
        if (results.body.isValid)
        {
          this.openSB("Ubicación configurada");
          this.dialogRef.close(true);
        }
        else
        {
          alert(results.body.error.description);
        }
      },
        (e) => {
          this.mensaje = e.error;
          console.log(e);
        }
      );
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  hasError(nombreControl: string, validacion: string) {
    const control = this.formedit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 3000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  
}
